import rtti from '@/sui/tools/rtti'

function newField (k, l, t, p, c, b, o, s, v, e) {
  const result = {
    key: k,
    label: l,
    text: t,
    placeholder: p,
    class: c == null ? 'col-xs-12' : c,
    options: o,
    show: s,
    convert: v,
    allowEmpty: e
  }

  if (rtti.isString(b)) {
    result.blur = (f, m) => {
      f.error = f.value === '' ? b : ''
    }
  } else {
    result.blur = b
  }

  return result
}

function newChoices (k, l, t, ch, s, c) {
  return {
    class: c == null ? 'col-xs-12' : c,
    type: 1,
    key: k,
    label: l,
    text: t,
    show: s,
    choices: ch
  }
}

function newYesNoNCNA (k, l, t, s, c) {
  const ch = [
    {
      key: 'yes',
      label: 'OUI',
      value: 1
    },
    {
      key: 'no',
      label: 'NON',
      value: 2
    },
    {
      key: 'nc',
      label: 'NON CONNU / NON APPLICABLE',
      value: 9
    }
  ]
  return newChoices(k, l, t, ch, s, c)
}

function newYesNo (k, l, t, s, c) {
  const ch = [
    {
      key: 'yes',
      label: 'OUI',
      value: 1
    },
    {
      key: 'no',
      label: 'NON',
      value: 2
    },
    {
      key: 'nc',
      label: 'NON CONNU',
      value: 9
    }
  ]
  return newChoices(k, l, t, ch, s, c)
}

function newDate (k, l, t, b, c, s) {
  const f = newField(
    k, l, t, 'jj/mm/aaaa', c, b, {
      date: true,
      datePattern: ['d', 'm', 'Y']
    }, s, null
  )

  f.convert = (v) => {
    const day = parseInt(v.substring(0, 2), 10)
    const month = parseInt(v.substring(2, 4), 10)
    const year = parseInt(v.substring(4, 8), 10)
    return new Date(year, month - 1, day, 10)
  }
  return f
}

function newModel (fields) {
  const result = {}
  fields.forEach(
    f => {
      result[f.key] = {
        error: '',
        value: ''
      }
    }
  )
  return result
}

function resetModel (model, fields) {
  fields.forEach(
    f => {
      model[f.key].error = ''
      model[f.key].value = ''
    }
  )
}

export default {
  newField,
  newChoices,
  newYesNo,
  newYesNoNCNA,
  newDate,
  newModel,
  resetModel
}
